import { AwaitResponse } from '@general/js/utils/MockUtils';
import {
  captureAdditionalInformationReferenceData,
  changeCoverReferenceData,
  fundNames,
  submitChangeCoverResponse,
  terminationReasonFlexCodes,
  mpCoverDetails,
  addRemovePersonReferenceData,
  MemberPolicies
} from '@/constants/MyCoverServicesMockApiData';
import ChangeCoverAbstractServices from './ChangeCoverAbstractServices';

export default class ChangeCoverServices extends ChangeCoverAbstractServices {
  /**
   * Mock reference data for change cover landing page
   */
  static getChangeCoverLandingPageReferenceData() {
    return AwaitResponse(JSON.parse(JSON.stringify(changeCoverReferenceData).tokenSwap()));
  }

  static getAddRemovePersonReferenceData() {
    return AwaitResponse(addRemovePersonReferenceData);
  }

  static async getMpCoverDetails() {
    return AwaitResponse(mpCoverDetails);
  }

  static getPremiumImpactReferenceData() {
    return AwaitResponse({
      headingText: {
        informationText: 'Your cover has been updated',
      },
      informationText: {
        informationText:
          'We&#39;ll send a new certificate of cover confirming the changes you&#39;ve made (including any new waiting periods).<br />\r\n<br />\r\nThese changes may impact your rebate, please call &nbsp;us on <a href="tel://1800335425">1800 335 425</a> to change to discuss changing your rebate if this is required.',
      },
      productInformationText: {
        informationText:
          'The next payment amount shown below does not consider any changes that may occur on the policy in the next payment period such as loading or discount removal. If any changes do occur between the current date and the next payment date this amount may vary.&nbsp;',
      },
      paymentAdjustedText: {
        informationText: 'Your next payment may be adjusted to account for your policy update.',
      },
    });
  }

  static async getCaptureAdditionalInformationReferenceData() {
    return AwaitResponse(captureAdditionalInformationReferenceData);
  }

  static async getTerminationReasonFlexCodes() {
    return AwaitResponse(terminationReasonFlexCodes);
  }

  static async getFundNames() {
    return AwaitResponse(fundNames.value);
  }

  static async submitChangeCover() {
    return AwaitResponse(JSON.parse(submitChangeCoverResponse.responseString));
  }

  static async getDuplicatePerson(firstName) {
    if (firstName === 'duplicate') {
      return AwaitResponse(true);
    }
    return AwaitResponse(false);
  }

  static async raiseDuplicatePersonWorkItem() {
    return AwaitResponse(true);
  }

  static async retrieveNewPolicyScaleFromEAI() {
    return AwaitResponse({
      newScale: 'single',
    });
  }

  static async retrieveNewPolicyPremiumFromEAI() {
    return AwaitResponse({
      productCode: [],
      calculationResultSetTotalBasePremium: 'Decimal',
      calculationResultSetTotalSurcharge: 'Decimal',
      calculationResultSetTotalAdjustment: 'Decimal',
      calculationResultSetTotalResult: 100.23,
      discounts: {
        rebateDiscount: '10%', // String - can be null
        dvaDiscount: '5%', // String - can be null
        abdDiscount: '5%', // String - can be null
        adfDiscount: '10%', // String - can be null
        lhcDiscount: '20%', // String - can be null
      },
    });
  }

  static async fetchMemberProductHistory(memberNumber, personCode) {
    let response = {};

    // Mock policy holder response
    if (personCode === 'Member-1002') {
      response = {
        policies: [
          {
            memberNumber,
            productHistory: {
              productInfo: [
                {
                  startDate: '2024-01-22',
                  endDate: '2024-01-30',
                  name: 'Value Extras',
                  type: 'extras',
                },
                {
                  startDate: '2024-01-23',
                  endDate: '',
                  name: 'Ultimate Hospital Gold',
                  type: 'hospital',
                },
              ],
            },
          },
          {
            memberNumber: '12345',
            productHistory: {
              productInfo: [
                {
                  startDate: '2024-01-20',
                  endDate: '2024-01-21',
                  name: 'Premier Extras',
                  type: 'extras',
                },
              ],
            },
          },
        ],
      };
    } else {
      response = {
        policies: [
          {
            memberNumber,
            productHistory: {
              productInfo: [
                {
                  startDate: '2024-01-23',
                  endDate: '',
                  name: 'Ultimate Hospital Gold',
                  type: 'hospital',
                },
              ],
            },
          },
          {
            memberNumber: '56789',
            productHistory: {
              productInfo: [
                {
                  startDate: '2024-01-20',
                  endDate: '2024-01-21',
                  name: 'ADF Total Package Gold',
                  type: 'package',
                },
              ],
            },
          },
        ],
      };
    }

    return AwaitResponse(response);
  }

  static getMemberPolicies() {
    return AwaitResponse(MemberPolicies);
  }
}
